import { EditorState, convertFromHTML, ContentState } from "draft-js";
import { CAMPAIGN_STATES, UPDATE_FORM_FIELDS } from "./CampaignActions";
import moment from "moment";

const _nullState = {
  // isTutorial: true,
  // activeTutorial: "home-overview", // first-video, video-detail, home-overview
  activeStep: 1,
  // isVistComplete: false,
  totalSteps: 5,
  qrModal: false,
  form: {
    _id: "",
    campaign_headline: "",
    campaign_hashtag: "",
    campaign_brand_name: "",
    campaign_product: "",
    campaign_banner_image: "",
    campaign_banner_image_file: null,
    productimageURL: "",
    campaign_brand_image_preview: "",
    campaign_brand_image: "",
    campaign_description: "",
    brand_instruction: "",
    campaign_headline_editor: "",
    campaign_reward: "",
    end_date: null,
    time: "",
    start_date: moment(),
    start_time: "",
    end_time: "",
    campaign_timezone: "GMT-07:00 (Pacific Daylight Time)",
    currentTime: "",
    campaign_reward_type: "",
    ongoing: false,
    products: [],
    campaign_video_limit: 200, //Backend
    campaign_video_length: "",
    campaign_allow_rating: false,
    banner_with_qr: "",
    terms_and_conditions: "",
    image_dimensions: "Fit",
    description_editor_state: null,
    brand_instruction_editor_state: null,
    terms_and_conditions_editor_state: null,
    headline_editor_state: null,
    hashtag_editor_state: null,
    campaign_hashtag_editor: "",
    preview_color_change: "#526261",
    // color_change_hashtag: "#FC80BB",
    campaign_video_length_type: "",
    campaign_button_color: "#96C392",
    campaign_button_text_color: "white",
    campaign_upload_platform: [],
  },
  campaign_response: null,
  timezones: [
    {
      value: "GMT-10:00 (Hawaii Standard Time)",
      label: "(GMT -10:00) Hawaii Standard Time",
    },
    {
      value: "GMT-09:00 (Hawaii-Aleutian Daylight Time)",
      label: "(GMT -09:00) Hawaii-Aleutian Daylight Time",
    },
    {
      value: "GMT-09:00 (Alaska Daylight Time)",
      label: "(GMT -09:00) Alaska Daylight Time",
    },
    {
      value: "GMT-07:00 (Pacific Daylight Time)",
      label: "(GMT -07:00) Pacific Daylight Time",
    },
    {
      value: "GMT-06:00 (Mountain Daylight Time)",
      label: "(GMT -06:00) Mountain Daylight Time",
    },
    {
      value: "GMT-05:00 (Central Daylight Time)",
      label: "(GMT -05:00) Central Daylight Time",
    },
    {
      value: "GMT-04:00 (Eastern Daylight Time)",
      label: "(GMT -04:00) Eastern Daylight Time",
    },
  ],
};

export const campaign_states = (state = _nullState, { type, status }) => {
  switch (type) {
    case CAMPAIGN_STATES:
      return { ...state, ...status };
    case UPDATE_FORM_FIELDS:
      return {
        ...state,
        form: {
          ...state.form,
          ...status,
        },
      };
    default:
      return state;
  }
};
